// @flow
// React
import React, {useState} from 'react';
import type {Node} from 'react';

// WS
import {Box, Stack, Typography, Select} from '@wellstone-solutions/web';
import {LoadingIndicator} from 'components/shared/LoadingIndicator';
import {Palette} from 'palette';
import {PfScatterChart} from './ScatterChart';
import {useTags} from '../hooks/useTags';

type PropsType = {
  aggregator: string,
  checkinData: Array<{
    name: string,
    color: string,
    data: Array<{
      date?: string,
      index: number,
      value: number,
      value_userlist: Array<string>,
    }>,
  }>,
  initialFilter?:
    'PAWS' | 'AW' | 'Physical' | 'Behavioral' | 'Safety' | 'General' | 'None',
  showDetailsModal?: boolean,
};

export const PfCheckinChart = ({
  aggregator,
  checkinData,
  initialFilter = 'General',
  showDetailsModal,
}: PropsType): Node => {
  const [selectedFilterName, setSelectedFilterName] = useState(initialFilter);
  const tags = useTags();

  const filters = [{name: 'None', type: null, key: null}, ...tags];

  const _getActiveFilter = () =>
    // $FlowIgnore
    filters.find((filter) => filter.name === selectedFilterName);

  const _handleFilterCheckins = (name) => {
    setSelectedFilterName(name);
  };

  if (!checkinData) {
    return <LoadingIndicator />;
  }
  return (
    <Stack direction="column">
      <Stack
        direction="row"
        justifyContent="flex-end"
        alignItems="center"
        sx={{marginBottom: 4}}>
        <Typography sx={styles.viewBy}>Filtered By</Typography>
        <Box>
          <Select
            value={selectedFilterName}
            onChange={(event) => _handleFilterCheckins(event.target.value)}
            items={filters.map((filter) => ({
              value: filter.name,
              label: filter.name,
            }))}
            canUnselect={false}
            containerProps={{
              size: 'small',
              sx: {minWidth: 150},
            }}
          />
        </Box>
      </Stack>
      <Box>
        <PfScatterChart
          size={{height: 400, width: '95%'}}
          filterData={_getActiveFilter()}
          scatterData={checkinData}
          x={{key: aggregator, type: 'category'}}
          y={{key: 'index', type: 'number'}}
          showDetailsModal={showDetailsModal ?? true}
        />
      </Box>
    </Stack>
  );
};

const styles = {
  viewBy: {
    marginRight: 2,
    fontWeight: 'bold',
    color: Palette.INFO,
  },
};
